import { BaseWidget } from ".";
import BrowserNotSupportedIcon from '@mui/icons-material/BrowserNotSupported';

/**
 * Used to render old/unsupported widgets that cannot be rendered in this version of the editor. 
 */
export class PlaceholderWidget extends BaseWidget {
    
    getName() {
        return 'Niet ondersteund';
    }

    getIcon() {
        return <BrowserNotSupportedIcon />;
    }

    getControls() {
        return {}
    }

    /**
     * @param {{
     *     [K in keyof ReturnType<typeof this.getControls>]: ReturnType<typeof this.getControls>[K]['defaultValue']
     * }} props
     * @returns {React.ReactNode}
     */
    render(props) {
        return <p style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }}>
            <BrowserNotSupportedIcon /> Niet-ondersteunde widget
        </p>
    }
}